// Regra de abastecimento/compra precisa de quantidade inteira >= 1. Campo apagado
// (null) ia pro backend e voltava 400 "quantity must be a number".
export const validateRuleQuantity = (quantity: unknown): string | undefined =>
  Number.isInteger(quantity) && (quantity as number) >= 1 ? undefined : 'Informe a quantidade (inteiro, pelo menos 1)'
